import { Dialog, DialogContent, styled } from '@mui/material';

const ConfirmationDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    borderRadius: '12px',
    padding: '24px',
    minWidth: '200px'
  }
});

const ConfirmationContent = styled(DialogContent)({
  padding: '0 !important',
  '& .MuiDialogContent-root': {
    padding: '0'
  }
});

export { ConfirmationContent, ConfirmationDialog };
